import LegalNotice, { PATH as LEGAL_NOTICE } from './LegalNotice'

export default { LegalNotice }
export const PATH = { LEGAL_NOTICE }
